<template>
  <div id="print">

    <div class="book m-auto">

      <div
        v-for="(data, idx) in Math.ceil(goodsreceipt.orders.length/maxOrderLists)"
        :key="idx"
        class="page">
        <div class="subpage">
          <div
            class="top-header"
            style="padding: 0 0 30px 0;">
            <div
              v-if="idx == 0"
              class="company-info">
              <img
                v-if="shopInfo.logo.thumbnail"
                :src="shopInfo.logo.thumbnail">
              <div class="name">
                <strong class="text-black">{{ shopInfo.shop_name }}</strong>
                <p>{{ shopInfo.info.location.address }}</p>
              </div>
            </div>
            <div class="document-type">
              <h2 class="text-black">{{ $t('documents.gr') }}</h2>
              <p>{{ goodsreceipt.gr_code }}</p>
            </div>
          </div>
          <div
            v-if="idx == 0"
            class="content">
            <div class="left">
              <div class="section">
                <p class="label">{{ $t('message.vendor') }}</p>
                <p class="detail">{{ goodsreceipt.vendor.vendor_name }}</p>
              </div>
              <div
                v-if="getPartnerContact(goodsreceipt.vendor.contacts).tel"
                class="section">
                <p class="label">{{ $t('message.tel') }}</p>
                <p class="detail">{{ getPartnerContact(goodsreceipt.vendor.contacts).tel }}</p>
              </div>
              <div
                v-if="goodsreceipt.vendor.address"
                class="section">
                <p class="label">{{ $t('message.address') }}</p>
                <p class="detail">{{ goodsreceipt.vendor.address }}</p>
              </div>
            </div>
            <div class="right">
              <div class="section">
                <p class="label">{{ $t('apps.inventory.message.receiptdate') }}</p>
                <p class="detail">{{ getDateTime(goodsreceipt.scheduled_at) }}</p>
              </div>
              <div class="section">
                <p class="label">{{ $t('apps.inventory.message.postingatreceivedorders') }}</p>
                <p class="detail">
                  {{ goodsreceipt.posting_at ? getDateTime(goodsreceipt.posting_at) : '-' }}
                </p>
              </div>
            </div>
          </div>
          <div class="order">
            <table>
              <thead>
                <tr>
                  <td width="10px"><b>#</b></td>
                  <td width="40%"><b>{{ $t('message.description') }}</b></td>
                  <td v-if="showBinColumn"><b>{{ $t('apps.inventory.label.bin') }}</b></td>
                  <td class="text-right"><b>{{ $t('message.quantity') }}</b></td>
                  <td class="text-right"><b>{{ $t('status.gr.done') }}</b></td>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="({ item, quantity, done, bin_location_id }, idx_) in groupOrders[idx].orders"
                  :key="idx_">
                  <td width="10px"><b>{{ (maxOrderLists*idx)+(idx_+1) }}</b></td>
                  <td width="40%">{{ item }}</td>
                  <td v-if="showBinColumn">{{ getBinNameBy(bin_location_id) }}</td>
                  <td class="text-right">{{ getNumber(quantity) }}</td>
                  <td class="text-right">{{ getNumber(done) }}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            v-if="Math.ceil(goodsreceipt.orders.length/maxOrderLists) > 0 && idx !== (Math.ceil(goodsreceipt.orders.length/maxOrderLists)-1)"
            class="next-page">
            {{ $t('message.havenextpage') }}
          </div>

          <div
            v-if="idx >= (Math.ceil(goodsreceipt.orders.length/maxOrderLists)-1)"
            class="footer">

            <div class="note">
              <div
                v-if="goodsreceipt.note"
                class="section">
                <p>{{ $t('message.note') }}</p>
                <p style="white-space: pre;word-wrap: break-word; overflow-wrap: break-word; white-space: normal;">{{ goodsreceipt.note }}</p>
              </div>
            </div>

            <div class="total">

              <div class="section">

                <div class="section row m-0">
                  <div class="label">
                    {{ $t('apps.inventory.message.shipto') }}
                  </div>
                  <div class="detail text-right">
                    <span class="text-underline-border">{{ warehouseName }}</span>
                  </div>
                </div>

              </div>

            </div>

          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import _ from 'lodash'

export default {
  props: {
    goodsreceipt: {
      type: Object,
    },
  },
  data () {
    return {
      maxOrderLists: 15,
    }
  },
  computed: {
    ...mapGetters({
      shopInfo: 'getShopInfo',
      getPartnerContact: 'getPartnerContact',
      getWarehouseInfo: 'getWarehouseInfo',
      getBinNameBy: 'getBinNameBy',
    }),
    groupOrders () {
      var results = []
      var currentIdx = 0

      for (let i = 0; i < Math.ceil(this.goodsreceipt.orders.length / this.maxOrderLists); i++) {
        var page = i + 1
        results.push({
          'page': page,
          'orders': [],
        })
      }

      for (let i = 0; i < this.goodsreceipt.orders.length; i++) {
        let order = this.goodsreceipt.orders[i]

        if (i % (this.maxOrderLists) == 0 && i !== 0) {
          currentIdx++
        }

        results[currentIdx].orders.push(order)
      }

      return results
    },
    warehouseName () {
      return this.getWarehouseInfo(this.goodsreceipt.stockin.warehouse_id).warehouse_name
    },
    showBinColumn() {
      return this.goodsreceipt.orders.reduce((acc, cur) => {
        if (cur.bin_location_id != null) {
          acc = true
        }
        return acc
      }, false)
    },
  },
}
</script>

<style scoped>
  @page {
      size: A4;
      margin: 0;
  }

  @media print {
      #print .page {
          margin: 0;
          border: initial;
          border-radius: initial;
          width: initial;
          min-height: initial;
          box-shadow: initial;
          background: initial;
          page-break-after: always;
      }
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/inventory/goodsreceipt/include/PrintGr.vue